export default __webpack_public_path__ + "static/media/WNLwireframe.e57fb6b2.jpg";